import { ExclamationCircleGray300Icon } from '@assets/iconComponents';
import { Text } from '..';
import { colorSet } from '@theme';
import { Button } from '@mui/material';
import { useSelector } from '@stores';
import { PathnameEnum, UserRoleEnum } from '@constant';
import { useNavigate } from 'react-router';

// 유저의 계정 권한으로 접속 불가능한 페이지에 접근시 보여줌
export const ForbiddenElement = () => {
  const userRole = useSelector((state) => state.auth.role);

  const navigate = useNavigate();

  const getAccessMessage = () => {
    switch (userRole) {
      case UserRoleEnum['일반 회원']:
        return '데이터 관리자 이상부터 접근 가능합니다.';
      case UserRoleEnum['데이터 관리자']:
        return '최고 관리자 이상부터 접근 가능합니다.';
      case UserRoleEnum['최고 관리자']:
        return '루트 관리자만 접근 가능합니다.';
      default:
        return '';
    }
  };

  const getButtonText = () => {
    if (userRole === UserRoleEnum['일반 회원']) {
      return 'REFA 메인 페이지로 돌아가기';
    } else {
      return '돌아가기';
    }
  };

  const handleGoBack = () => {
    switch (userRole) {
      case UserRoleEnum['일반 회원']:
        navigate(PathnameEnum.MAIN_PAGE);
        break;
      case UserRoleEnum['데이터 관리자']:
        navigate(PathnameEnum.ADMIN_STANDARD_IMAGE_LIST_PAGE);
        break;
      case UserRoleEnum['최고 관리자']:
        navigate(PathnameEnum.ADMIN_STANDARD_IMAGE_LIST_PAGE);
        break;
      default:
        navigate(-1); // 브라우저 히스토리 한 단계 뒤로;
    }
  };

  return (
    <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center' }}>
        <ExclamationCircleGray300Icon style={{ width: 60, height: 60 }} />
        <Text variant="h3" color={colorSet.gray500}>
          해당 페이지 접근 권한이 없습니다.
        </Text>
        <Text variant="body1" color={colorSet.gray400}>
          {getAccessMessage()}
        </Text>
        <Button onClick={handleGoBack} variant="outlined" color="secondary">
          {getButtonText()}
        </Button>
      </div>
    </div>
  );
};
